<template>
    <div class="main">
        <c-panel title="ALMOXARIFADO — MONITOR DE PEDIDOS" titleIcon="fas fa-truck-loading">
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="7" v-if="ehSmed">
                        <el-form-item label="Solicitante">
                            <el-select v-model="filtro.instituicao_solicitante_id" placeholder="Todas" filterable clearable style="width:100%;" @change="load(1)">
                                <el-option v-for="i in $store.state.instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Status">
                            <el-select v-model="filtro.status" placeholder="Todos" clearable @change="load(1)" style="width:100%;">
                                <el-option :value="1" label="Aberto"></el-option>
                                <el-option :value="2" label="Em atendimento"></el-option>
                                <el-option :value="3" label="Atendido"></el-option>
                                <el-option :value="4" label="Cancelado"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" class="u-text-right" style="padding-top: 30px;">
                        <el-button type="primary" icon="el-icon-plus" @click="abrirNovo">NOVO PEDIDO</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width:150px;">Número</th>
                            <th style="width:90px;">Data</th>
                            <th>Solicitante</th>
                            <th>Fornecedora</th>
                            <th style="width:60px;" class="u-text-center">Itens</th>
                            <th style="width:120px;" class="u-text-center">Status</th>
                            <th style="width:280px;" class="u-text-center">Ações</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="p in items" :key="p.id">
                            <td>{{ p.numero }}</td>
                            <td>{{ p.data_pedido | formatarData }}</td>
                            <td>{{ p.solicitante ? p.solicitante.nome : '—' }}</td>
                            <td>{{ p.fornecedora ? p.fornecedora.nome : '—' }}</td>
                            <td class="u-text-center">{{ p.itens ? p.itens.length : 0 }}</td>
                            <td class="u-text-center"><el-tag size="mini" :type="tagStatus(p.status)">{{ rotuloStatus(p.status) }}</el-tag></td>
                            <td class="u-text-center acao">
                                <el-button size="mini" plain icon="el-icon-view" title="Ver itens" @click="ver(p)"></el-button>
                                <el-button class="u-ml-10" v-if="p.status === 1 || p.status === 2" size="mini" type="success" plain @click="abrirAtender(p)">ATENDER</el-button>
                                <el-button class="u-ml-10" v-if="p.status === 1" size="mini" type="danger" plain @click="cancelar(p.id)">CANCELAR</el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length"><td colspan="7" class="u-text-center" style="color:#909399;padding:15px;">Nenhum pedido encontrado.</td></tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12"><div class="u-text-left u-mt-10">Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.</div></el-col>
                    <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens" @current-change="load" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <!-- Novo pedido -->
            <el-dialog title="Novo pedido" :visible.sync="modalNovoVisivel" width="70%">
                <el-form label-position="top" class="u-mt-10">
                    <el-row :gutter="10">
                        <el-col :sm="12">
                            <el-form-item label="Instituição solicitante">
                                <el-select v-model="form.instituicao_solicitante_id" :disabled="!ehSmed" filterable placeholder="Selecione" style="width:100%;">
                                    <el-option v-for="i in $store.state.instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="12">
                            <el-form-item label="Instituição fornecedora">
                                <el-select v-model="form.instituicao_fornecedora_id" filterable clearable placeholder="Selecione (almoxarifado que atende)" style="width:100%;">
                                    <el-option v-for="i in $store.state.instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="Observação"><el-input v-model="form.observacao"></el-input></el-form-item>
                    <h4>Itens</h4>
                    <table class="table">
                        <thead><tr><th>Produto</th><th style="width:150px;">Quantidade</th><th style="width:50px;"></th></tr></thead>
                        <tbody>
                            <tr v-for="(item, i) in form.itens" :key="i">
                                <td>
                                    <el-select v-model="item.produto_id" filterable remote clearable :remote-method="buscarProduto" placeholder="Digite..." style="width:100%;">
                                        <el-option v-for="p in produtosBusca" :key="p.id" :label="p.codigo + ' — ' + p.nome" :value="p.id"></el-option>
                                    </el-select>
                                </td>
                                <td><el-input-number v-model="item.quantidade_solicitada" :min="0.001" :precision="3" controls-position="right" style="width:100%;"></el-input-number></td>
                                <td><el-button size="mini" type="danger" plain icon="el-icon-delete" @click="form.itens.splice(i, 1)"></el-button></td>
                            </tr>
                        </tbody>
                    </table>
                    <el-button size="small" plain icon="el-icon-plus" @click="form.itens.push({ produto_id: null, quantidade_solicitada: 1 })">+ ITEM</el-button>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalNovoVisivel = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="salvar">CRIAR PEDIDO</el-button>
                </span>
            </el-dialog>

            <!-- Atender pedido -->
            <el-dialog title="Atender pedido" :visible.sync="modalAtenderVisivel" width="70%">
                <p v-if="pedidoAtual"><strong>{{ pedidoAtual.numero }}</strong> — fornecedora: {{ pedidoAtual.fornecedora ? pedidoAtual.fornecedora.nome : '—' }}</p>
                <table class="table">
                    <thead><tr><th>Produto</th><th class="u-text-right">Qtd solicitada</th><th class="u-text-right">Já atendido</th><th style="width:170px;">Atender agora</th></tr></thead>
                    <tbody>
                        <tr v-for="it in atendimentos" :key="it.item_id">
                            <td>{{ it.produto_nome }}</td>
                            <td class="u-text-right">{{ Number(it.quantidade_solicitada).toFixed(3) }}</td>
                            <td class="u-text-right">{{ Number(it.quantidade_atendida).toFixed(3) }}</td>
                            <td><el-input-number v-model="it.quantidade" :min="0" :precision="3" controls-position="right" style="width:100%;"></el-input-number></td>
                        </tr>
                    </tbody>
                </table>
                <i style="color:#909399;">O atendimento gera transferências automáticas da fornecedora para a solicitante.</i>
                <span slot="footer">
                    <el-button @click="modalAtenderVisivel = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="success" @click="confirmarAtender">CONFIRMAR ATENDIMENTO</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    filters: { formatarData (v) { return v ? moment(v).format('DD/MM/YYYY') : '' } },
    data () {
        return {
            statusList: false,
            items: [],
            filtro: { instituicao_solicitante_id: '', status: '' },
            paginate: { page: 1, qtdItens: null, from: '', to: '' },
            modalNovoVisivel: false,
            form: this.formVazio(),
            produtosBusca: [],
            modalAtenderVisivel: false, pedidoAtual: null, atendimentos: []
        }
    },
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) }
    },
    mounted () {
        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_solicitante_id = this.$store.state.config.instituicao.id
        }
        this.load(1)
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        instId () { const i = this.$store.state.config.instituicao; return i && i.id ? i.id : null },
        formVazio () {
            return { instituicao_solicitante_id: '', instituicao_fornecedora_id: null, observacao: '', itens: [{ produto_id: null, quantidade_solicitada: 1 }] }
        },
        rotuloStatus (s) { return { 1: 'Aberto', 2: 'Em atendimento', 3: 'Atendido', 4: 'Cancelado' }[s] || '?' },
        tagStatus (s) { return { 1: 'info', 2: 'warning', 3: 'success', 4: 'danger' }[s] || '' },

        load (page) {
            this.paginate.page = page || 1
            this.statusList = false
            this.items = []
            const payload = { instituicao_solicitante_id: this.filtro.instituicao_solicitante_id || '', status: this.filtro.status || '' }
            this.$axios.post(`${this.baseUrl()}/api/almox-pedido/getAllPaginate?page=${this.paginate.page}`, payload, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.items = r.data.data
                    this.paginate.qtdItens = r.data.total
                    this.paginate.from = r.data.from
                    this.paginate.to = r.data.to
                    this.statusList = true
                }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        buscarProduto (q) {
            if (!q || q.length < 2) return
            this.$axios.post(`${this.baseUrl()}/api/almox-produto/getAllPaginate`, { busca: q, situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.produtosBusca = (r.data && r.data.data) ? r.data.data : [] })
        },
        abrirNovo () {
            this.form = this.formVazio()
            this.form.instituicao_solicitante_id = this.ehSmed ? '' : this.instId()
            this.modalNovoVisivel = true
        },
        salvar () {
            if (!this.form.instituicao_solicitante_id) { window.eventBus.$emit('alert', { msg: 'Selecione a instituição solicitante.', type: 'warning' }); return }
            const itens = this.form.itens.filter(i => i.produto_id && i.quantidade_solicitada > 0)
            if (!itens.length) { window.eventBus.$emit('alert', { msg: 'Informe pelo menos um item.', type: 'warning' }); return }
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.baseUrl()}/api/almox-pedido/store`, { ...this.form, itens }, this.$store.getters.getHeaderAuth).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: 'Pedido criado.', type: 'success' })
                this.modalNovoVisivel = false
                this.load(1)
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        cancelar (id) {
            this.$msgbox.confirm('Cancelar pedido?', 'Confirmar', { type: 'warning', confirmButtonText: 'Sim', cancelButtonText: 'Não' }).then(() => {
                this.$axios.post(`${this.baseUrl()}/api/almox-pedido/mudarStatus/${id}`, { status: 4 }, this.$store.getters.getHeaderAuth)
                    .then(() => { window.eventBus.$emit('alert', { msg: 'Pedido cancelado.', type: 'success' }); this.load(this.paginate.page) })
            }).catch(() => {})
        },
        ver (p) {
            const html = (p.itens && p.itens.length)
                ? p.itens.map(i => `${i.produto ? i.produto.nome : '?'} — ${Number(i.quantidade_solicitada).toFixed(3)} (atendido: ${Number(i.quantidade_atendida || 0).toFixed(3)})`).join('<br>')
                : 'Sem itens'
            this.$alert(html, 'Pedido ' + p.numero, { dangerouslyUseHTMLString: true })
        },
        abrirAtender (p) {
            this.pedidoAtual = p
            this.atendimentos = (p.itens || []).map(it => ({
                item_id: it.id,
                produto_nome: it.produto ? it.produto.nome : '?',
                quantidade_solicitada: it.quantidade_solicitada,
                quantidade_atendida: it.quantidade_atendida,
                quantidade: Number(it.quantidade_solicitada) - Number(it.quantidade_atendida || 0)
            }))
            this.modalAtenderVisivel = true
        },
        confirmarAtender () {
            const payload = { atendimentos: this.atendimentos.filter(a => a.quantidade > 0).map(a => ({ item_id: a.item_id, quantidade: a.quantidade })) }
            if (!payload.atendimentos.length) { window.eventBus.$emit('alert', { msg: 'Informe as quantidades a atender.', type: 'warning' }); return }
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.baseUrl()}/api/almox-pedido/atender/${this.pedidoAtual.id}`, payload, this.$store.getters.getHeaderAuth).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: 'Pedido atendido (transferências geradas).', type: 'success' })
                this.modalAtenderVisivel = false
                this.load(this.paginate.page)
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        }
    }
}
</script>
